module.exports = __webpack_public_path__ + "img/corporate-business.cdf0a23f.png";